@if (hasSponsoredContentRelevant()) {
  <div class="flex items-center justify-between">
    <div class="flex flex-col">
      <span class="text-sm">
        {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.advanced.sponsoredContentRelevant' | translate }}
      </span>
      <span class="text-xs text-shikenso-purple-base-60">
        {{
          'pages.campaignForm.ctaDialog.ctaDetails.deliverables.advanced.sponsoredContentRelevantDescription'
            | translate
        }}
      </span>
    </div>

    <div class="flex items-center gap-2">
      <mat-slide-toggle [hideIcon]="true" [formControl]="sponsoredContentRelevantControl" />

      <!-- Static space for revert button to prevent layout shift -->
      <div class="w-9 flex justify-center">
        @if (isCustomMode() && !isViewMode() && !form().value.exclusiveTo && hasSponsoredContentCustomValue()) {
          <button
            mat-icon-button
            type="button"
            class="mat-secondary-transparent-button-color"
            (click)="onRevertSponsoredContentRelevant()"
          >
            <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
          </button>
        }
      </div>
    </div>
  </div>
}
